import createDictionnary from './createDictionnary';

const defaultDictionnary = createDictionnary([400, 600, 900, 1200, 2000], 50);
const getOptimalWidthAndHeight = defaultDictionnary.getOptimalWidthAndHeight;

export { defaultDictionnary, getOptimalWidthAndHeight };
